// CMA CGM SpotOn commodity list (labels mirror CMA's "Choose a commodity"
// dropdown). `code` is the value sent to CMA as commodityCode.
//
// NOTE: CMA's exact per-commodity codes come from their commodity referential,
// which requires a live API session to pull. Until those are captured, every
// entry sends "FAK" (Freight All Kinds) — the universally-accepted code that
// prices safely — while the chosen label is stored on the offer. When the real
// codes are captured, only the `code` values here need updating (single place).
export const CMA_COMMODITIES = [
  { label: "Freight All Kinds", code: "FAK", hazEligible: true },
  { label: "Aluminum", code: "FAK" },
  { label: "Alfalfa", code: "FAK" },
  { label: "Automotive Parts", code: "FAK" },
  { label: "Bentonite", code: "FAK" },
  { label: "Beverages, Spirits and Vinegar", code: "FAK" },
  { label: "Borax", code: "FAK" },
  { label: "Building Materials", code: "FAK" },
  { label: "Cement and Clinker", code: "FAK" },
  { label: "Ceramics and Tiles", code: "FAK" },
  { label: "Chemicals (non-hazardous)", code: "FAK" },
  { label: "Coffee, Tea and Spices", code: "FAK" },
  { label: "Cotton and Textiles", code: "FAK" },
  { label: "Electronics", code: "FAK" },
  { label: "Fertilizers", code: "FAK" },
  { label: "Fresh Fruit and Vegetables", code: "FAK" },
  { label: "Foodstuffs", code: "FAK" },
  { label: "Furniture", code: "FAK" },
  { label: "Glass and Glassware", code: "FAK" },
  { label: "Grains and Cereals", code: "FAK" },
  { label: "Iron and Steel", code: "FAK" },
  { label: "Machinery and Equipment", code: "FAK" },
  { label: "Marble and Granite", code: "FAK" },
  { label: "Metals and Metal Products", code: "FAK" },
  { label: "Minerals and Ores", code: "FAK" },
  { label: "Paper and Pulp", code: "FAK" },
  { label: "Plastics and Rubber", code: "FAK" },
  { label: "Project / Heavy Cargo", code: "FAK" },
  { label: "Pharmaceuticals", code: "FAK" },
  { label: "Scrap (metal / paper / plastic)", code: "FAK" },
  { label: "Seafood (frozen)", code: "FAK" },
  { label: "Stone and Aggregates", code: "FAK" },
  { label: "Timber and Wood Products", code: "FAK" },
  { label: "Tobacco", code: "FAK" },
  { label: "Tyres", code: "FAK" },
  { label: "Vehicles", code: "FAK" },
  { label: "Wine", code: "FAK" },
];

export const findCommodity = (label) =>
  CMA_COMMODITIES.find((c) => c.label.toLowerCase() === String(label || "").toLowerCase());

export default CMA_COMMODITIES;
